import AuthPermission from "@/modules/auth/services/Permission"

export default new class Permission extends AuthPermission {

}
